import React, { useEffect } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import ProgramPage from './ProgramPage';
import ProgramRequestPage from './ProgramRequestPage';
import { ApprovedInfoDialog } from './ApprovedInfoDialog';
import { useDispatch, useSelector } from 'react-redux';
import { changeCurrentEventAndUpdateProgram, fetchProgramDelayed } from '../../../slices/program-slice';
import { Loading } from '../../common/Loading/Loading';
import { toast } from 'react-toastify';
import { setCreateTokenError } from '../../../slices/client-voices-slice';
import { usePageVisibility } from '../../common/hooks/use-page-visibility';

function ProgramPageRouter() {
    const { eventName } = useParams();
    const dispatch = useDispatch();
    const { isLoading, approvedError } = useSelector((state) => ({
        isLoading: !state.program.program,
        approvedError: state.clientVoices.approvedError,
    }));
    useEffect(() => {
        dispatch(changeCurrentEventAndUpdateProgram(eventName || ''));
    }, [eventName, dispatch]);
    useEffect(() => {
        if (approvedError) toast.warn(approvedError);
        return () => dispatch(setCreateTokenError(null));
    }, [approvedError, dispatch]);
    usePageVisibility(() => {
        dispatch(fetchProgramDelayed());
    });

    console.log('render program index', isLoading);
    return (
        <>
            {isLoading ? (
                <div className="position-relative mt-5">
                    <Loading text="Ожидание данных..." />
                </div>
            ) : (
                <Routes>
                    <Route path={'request/:reqNum'} element={<ProgramRequestPage />} />
                    <Route path="" element={<ProgramPage />} />
                </Routes>
            )}
            <ApprovedInfoDialog />
        </>
    );
}

export default ProgramPageRouter;
